import { chartBackgroundColor } from "./globals";
import Highcharts from "highcharts";

// Assessment statuses chart colors and configuration
const levelChartColor = "#35778B"; // Original CMMC level chart color (teal)

document.addEventListener("turbo:load", () => {
  const charts: NodeListOf<HTMLElement> = document.querySelectorAll(
    "[data-chart='assessment_statuses_chart']",
  );

  if (charts) {
    Array.from(charts).forEach((chart) => {
      const titleData = JSON.parse(chart.dataset.title || '""');
      const seriesDataString = chart.dataset.seriesData || "[]";
      const seriesData = JSON.parse(seriesDataString);

      // Format title based on data type
      let titleText = "";
      if (typeof titleData === "object" && titleData !== null) {
        // Handle hash titles
        titleText = `<div>${titleData.count}</div><br/><div style="font-size: 14px">Out of ${titleData.client_count}</div><br/><div style="font-size: 14px">Clients</div>`;
      } else {
        // Handle string titles
        titleText = titleData;
      }

      Highcharts.chart({
        chart: {
          renderTo: chart,
          backgroundColor: chartBackgroundColor,
          spacing: [0, 0, 0, 0],
          type: "pie",
        },
        title: {
          text: titleText,
          align: "center",
          verticalAlign: "middle",
          style: {
            color: levelChartColor,
            fontSize: "5em",
            fontWeight: "bold",
          },
        },
        tooltip: {
          enabled: true,
          useHTML: true,
          headerFormat:
            '<div style="text-align: center; font-weight: bold">{point.key}</div>',
          pointFormat:
            '<div style="text-align: center">{point.y} Assessments</div>',
          valueDecimals: 0,
        },
        pane: {
          background: [
            {
              backgroundColor: "#E8ECF5",
              borderWidth: 0,
              innerRadius: "80%",
              outerRadius: "100%",
            },
          ],
        },
        plotOptions: {
          pie: {
            innerSize: "75%",
          },
        },
        series: [
          {
            type: "pie",
            data: seriesData,
            color: levelChartColor,
            dataLabels: {
              enabled: false,
            },
          },
        ],
      });
    });
  }
});
